import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { C } from "./homeTheme";
import { useTranslation } from "react-i18next";

export function BuyNoticeDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="max-w-sm mx-auto"
        style={{
          background: C.bg,
          border: `1px solid ${C.border}`,
          color: C.text,
        }}
      >
        <DialogHeader>
          <DialogTitle
            className="flex items-center gap-2"
            style={{ color: C.primary }}
          >
            <Shield size={16} />
            {t("homePage.buyNoticeDialog.title")}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-xs" style={{ color: C.muted }}>
          {[
            t("homePage.buyNoticeDialog.notice1"),
            // t("homePage.buyNoticeDialog.notice2"),
            t("homePage.buyNoticeDialog.notice3"),
            t("homePage.buyNoticeDialog.notice4"),
            t("homePage.buyNoticeDialog.notice5"),
            t("homePage.buyNoticeDialog.notice6"),
            t("homePage.buyNoticeDialog.notice7"),
          ].map((text, i) => (
            <div key={i} className="flex items-start gap-2">
              <div
                className="w-1 h-1 rounded-full mt-1.5 shrink-0"
                style={{ background: C.primary }}
              />
              {text}
            </div>
          ))}
        </div>
        <Button className="w-full btn-primary mt-2" onClick={onClose}>
          {t("homePage.buyNoticeDialog.confirm")}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
